import Vue from 'vue'
import VueI18n from 'vue-i18n'
import sc from './sc'
import tc from './tc'
import en from './en'
import ru from './ru'
import jp from './jp'
import es from './es'
import th from './th'
import hi from './hi'
import pt from './pt'
import kr from './kr'
import mn from './mn'
import vi from './vi'
import pl from './pl'
import fr from './fr'
import da from './da'


import { switchLanguage } from '../utils/switchLang.js'

Vue.use(VueI18n)

const messages = {
  sc,
  tc,
  en,
  ru,
  jp,
  es,
  th,
  hi,
  pt,
  kr,
  mn,
  vi,
  pl,
  fr,
  da
}

const getUrlParam = function (paraName) {
  const url = document.location.search
  const arrObj = url.split('?')
  if (arrObj.length > 1) {
    const arrPara = arrObj[1].split('&')
    let arr

    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=')

      if (arr !== null && arr[0] === paraName) {
        return arr[1]
      }
    }
    return ''
  } else {
    return ''
  }
}

const BrowLang = switchLanguage()
const queryLang = getUrlParam('lang')

const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  // eslint-disable-next-line no-prototype-builtins
  locale: queryLang ? (messages.hasOwnProperty(queryLang) ? queryLang : 'en') : BrowLang,
  // set locale messages
  messages
})

export default i18n
